module.exports = new Promise(async (resolve, reject) => {
  /* ─────────── 1. look up the URL ─────────── */
  const urlGetter = window.__mf_getUrl
  const remoteUrl = urlGetter && urlGetter('os_aioverview')

  if (!remoteUrl) {
    reject(new Error('No URL configured for remote "os_aioverview"'))
    return
  }
  if (!/^(https?):\/\//.test(remoteUrl)) {
    reject(new Error('Invalid URL for remote "os_aioverview": ' + remoteUrl))
    return
  }

  /* ─────────── 2. quick HEAD pre-flight (3s) ─────────── */
  const fetchWithTimeout = (url, timeoutMs = 3000) =>
    new Promise((res, rej) => {
      const t = setTimeout(() => rej(new Error('Timeout while checking ' + url)), timeoutMs)
      fetch(url, { method: 'HEAD' })
        .then(r => { clearTimeout(t); res(r) })
        .catch(e => { clearTimeout(t); rej(e) })
    })

  try {
    const head = await fetchWithTimeout(remoteUrl)
    if (!head.ok) {
      reject(new Error('Remote "os_aioverview" responded with HTTP ' + head.status))
      return
    }
  } catch (err) {
    reject(new Error('Failed to fetch remote "os_aioverview": ' + err.message))
    return
  }

  /* ─────────── 3· already loaded? ─────────── */
  if (window['os_aioverview']) {
    resolve(window['os_aioverview'])
    return
  }

  /* ─────────── 4· inject <script> and init ─────────── */
  const script = document.createElement('script')
  script.src = remoteUrl
  script.type = 'text/javascript'
  script.async = true

  script.onload  = () => resolve(window['os_aioverview'])

  script.onerror = () => {
    script.remove()
    reject(new Error('Failed to load remote "os_aioverview" from ' + remoteUrl))
  }

  document.head.appendChild(script)
});